import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [checked, setChecked] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [maintChecked, setMaintChecked] = useState(false);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setChecked(true));
  }, []);

  const refreshMaintenance = async () => {
    try {
      const { data } = await api.get("/system/maintenance");
      setMaintenance(!!data.enabled);
      return !!data.enabled;
    } catch {
      return false;
    } finally {
      setMaintChecked(true);
    }
  };

  useEffect(() => {
    if (!user || user === false) return;
    refreshMaintenance();
    const t = setInterval(refreshMaintenance, 20000);
    return () => clearInterval(t);
  }, [user]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  const can = (module) => {
    if (!user || user === false) return false;
    if (user.role === "admin") return true;
    const p = user.permissions || {};
    if (Array.isArray(p)) return p.includes(module);
    return !!(p[module] && p[module].length);
  };

  const canDo = (module, action) => {
    if (!user || user === false) return false;
    if (user.role === "admin") return true;
    const p = user.permissions || {};
    if (Array.isArray(p)) return p.includes(module);
    return (p[module] || []).includes(action);
  };

  return (
    <AuthContext.Provider value={{ user, checked, maintenance, maintChecked, refreshMaintenance, setMaintenance, login, logout, can, canDo }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
